import prepareHex from './prepareHex';
import isLightColor from './isLightColor';
import padStart from '../padStart';

export const invertColor = (hex: string, monochrome?: boolean) => {
  const preparedHex = prepareHex(hex);
  if (!preparedHex) {
    return '';
  }
  const red: number = parseInt(preparedHex.slice(0, 2), 16);
  const green: number = parseInt(preparedHex.slice(2, 4), 16);
  const blue: number = parseInt(preparedHex.slice(4, 6), 16);

  if (monochrome) {
    return isLightColor(preparedHex) ? '#262626' : '#FFFFFF';
  }
  // invert color components
  const newRed = Math.max(255 - red, 0).toString(16);
  const newGreen = Math.max(255 - green, 0).toString(16);
  const newBlue = Math.max(255 - blue, 0).toString(16);

  const newHex = '#'
    .concat(
      padStart(newRed, 2, '0'),
      padStart(newGreen, 2, '0'),
      padStart(newBlue, 2, '0'),
    )
    .toUpperCase();

  return newHex;
};

export default invertColor;
